import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import api from '../api'

const GET_PRODUCTS = createAction('products/GET_PRODUCTS')
const GET_PRODUCTS_SUCCESS = createAction('products/GET_PRODUCTS_SUCCESS')

const GET_PRODUCTS_FOR_COUNTRY = createAction('products/GET_PRODUCTS_FOR_COUNTRY')
const GET_PRODUCTS_FOR_COUNTRY_SUCCESS = createAction('products/GET_PRODUCTS_FOR_COUNTRY_SUCCESS')

const GET_DISPLAY_PRODUCTS = createAction('products/GET_DISPLAY_PRODUCTS')
const GET_DISPLAY_PRODUCTS_SUCCESS = createAction('products/GET_DISPLAY_PRODUCTS_SUCCESS')

const CREATE_PRODUCT = createAction('products/CREATE_PRODUCT')
const CREATE_PRODUCT_SUCCESS = createAction('products/CREATE_PRODUCT_SUCCESS')

const EDIT_PRODUCT = createAction('products/EDIT_PRODUCT')
const EDIT_PRODUCT_SUCCESS = createAction('products/EDIT_PRODUCT_SUCCESS')

const DELETE_PRODUCTS = createAction('products/DELETE_PRODUCTS')
const DELETE_PRODUCTS_SUCCESS = createAction('products/DELETE_PRODUCTS_SUCCESS')

const SET_DISPLAY_PRODUCT = createAction('products/SET_DISPLAY_PRODUCT')
const SET_DISPLAY_PRODUCT_SUCCESS = createAction('products/SET_DISPLAY_PRODUCT_SUCCESS')

const REMOVE_DISPLAY_PRODUCT = createAction('products/REMOVE_DISPLAY_PRODUCT')
const REMOVE_DISPLAY_PRODUCT_SUCCESS = createAction('products/REMOVE_DISPLAY_PRODUCT_SUCCESS')

const SET_ERROR = createAction('products/SET_ERROR')

const SELECT_ITEM = createAction('products/SELECT_ITEM')
const UNSELECT_ITEM = createAction('products/UNSELECT_ITEM')
const UNSELECT_ALL = createAction('products/UNSELECT_ALL')
const TOGGLE_ALL = createAction('products/TOGGLE_ALL')

const SET_ACTIVE = createAction('products/SET_ACTIVE')
const RESET_ACTIVE = createAction('products/RESET_ACTIVE')
const UPDATE_ACTIVE = createAction('products/UPDATE_ACTIVE')

const SET_DISPLAY = createAction('products/SET_DISPLAY')
const RESET_DISPLAY = createAction('products/RESET_DISPLAY')
const UPDATE_DISPLAY = createAction('products/UPDATE_DISPLAY')

const SET_NEW = createAction('products/SET_NEW')
const RESET_NEW = createAction('products/RESET_NEW')

const SET_PAGE = createAction('products/SET_PAGE')
const SET_ROWS_PER_PAGE = createAction('products/SET_ROWS_PER_PAGE')

const SET_SORT = createAction('products/SET_SORT')
const SET_FILTER = createAction('products/SET_FILTER')

const SET_ACTIVE_SUBPACK = createAction('products/SET_ACTIVE_SUBPACK')
const CLEAR_ACTIVE_SUBPACK = createAction('products/CLEAR_ACTIVE_SUBPACK')

const CLEAR_PRODUCTS = createAction('products/CLEAR_PRODUCTS')

const initialState = {
  items: [],
  productsForCountry: [],
  displayItems: [],
  selectedItems: [],
  allSelected: false,
  itemCount: 0,
  active: null,
  new: false,
  displayProduct: null,
  loading: false,
  sort: { orderBy: 'name', direction: 'asc' },
  filter: { country: '', productType: '' },
  rowsPerPage: 25,
  page: 0,
  subscriptionPack: null
}

export default handleActions(
  {
    [GET_PRODUCTS]: (state, action) => ({
      ...state,
      loading: true,
      itemCount: 0
    }),
    [GET_PRODUCTS_SUCCESS]: (state, action) => {
      action.payload.products.forEach(function (e) {
        e.checked = false
      })

      let items = !state.items.length ? action.payload.products
        : state.items.concat(action.payload.products.filter(x => 
          !state.items.find(y => y.id === x.id)))

      return {
        ...state,
        loading: false,
        items: items,
        itemCount: action.payload.totalCount
      }
    },
    [GET_PRODUCTS_FOR_COUNTRY]: (state, action) => ({
      ...state,
      productsForCountry: []
    }),
    [GET_PRODUCTS_FOR_COUNTRY_SUCCESS]: (state, action) => ({
      ...state,
      productsForCountry: action.payload.products
    }),
    [GET_DISPLAY_PRODUCTS]: (state, action) => ({
      ...state,
      loading: true,
      displayItems: []
    }),
    [GET_DISPLAY_PRODUCTS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      displayItems: action.payload.displayProducts
    }),
    [CREATE_PRODUCT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CREATE_PRODUCT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [EDIT_PRODUCT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [EDIT_PRODUCT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_PRODUCTS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_PRODUCTS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_DISPLAY_PRODUCT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [SET_DISPLAY_PRODUCT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [REMOVE_DISPLAY_PRODUCT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [REMOVE_DISPLAY_PRODUCT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = true
      state.selectedItems.push({ ...selectedItem })
      var all = state.items && state.selectedItems ? state.items.length === state.selectedItems.length : false

      return {
        ...state,
        items: state.items,
        selectedItems: state.selectedItems,
        allSelected: all
      }
    },
    [UNSELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = false
      var selectedItems = state.selectedItems.filter(function (element) {
        return element.id !== selectedItem.id
      })
      return {
        ...state,
        items: state.items,
        selectedItems: selectedItems,
        allSelected: false
      }
    },
    [UNSELECT_ALL]: (state, action) => ({
      ...state,
      selectedItems: [],
      allSelected: false
    }),
    [TOGGLE_ALL]: (state, action) => {
      var checked = !action.payload
      state.items.forEach(function (item) {
        item.checked = checked
      })
      return {
        ...state,
        items: state.items,
        selectedItems: checked ? [...state.items] : [],
        allSelected: checked
      }
    },
    [SET_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_ACTIVE]: (state, action) => ({
      ...state,
      active: { ...action.payload }
    }),
    [RESET_ACTIVE]: (state, action) => ({
      ...state,
      active: null
    }),
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    },
    [SET_DISPLAY]: (state, action) => {
      var displayProduct = action.payload.displayProduct || {}
      displayProduct.id = action.payload.productId
      var item = state.items.find(function (item) {
        return item.id === action.payload.productId
      })
      displayProduct.country = item.country
      return { ...state, displayProduct: { ...displayProduct } }
    },
    [RESET_DISPLAY]: (state, action) => ({
      ...state,
      displayProduct: null
    }),
    [UPDATE_DISPLAY]: (state, action) => {
      var display = state.displayProduct
      display[action.payload.name] = action.payload.value
      return { ...state, displayProduct: display }
    },
    [SET_NEW]: (state, action) => ({
      ...state,
      active: action.payload,
      new: true
    }),
    [RESET_NEW]: (state, action) => ({
      ...state,
      active: null,
      new: false
    }),
    [SET_PAGE]: (state, action) => ({
      ...state,
      page: action.payload
    }),
    [SET_ROWS_PER_PAGE]: (state, action) => ({
      ...state,
      rowsPerPage: action.payload
    }),
    [SET_SORT]: (state, action) => ({
      ...state,
      sort: {
        orderBy: action.payload,
        direction: state.sort.direction === 'asc' ? 'desc' : 'asc'
      }
    }),
    [SET_FILTER]: (state, action) => {
      let filter = state.filter
      filter[action.payload.name] = action.payload.value
      return { ...state, filter: filter }
    },
    [CLEAR_PRODUCTS]: (state, action) => ({
      ...state,
      items: []
    }),
    [SET_ACTIVE_SUBPACK]: (state, action) => {
      var active = state.active
      active.subscriptionPack = action.payload
      return {...state, active}
      
    },
    [CLEAR_ACTIVE_SUBPACK]: (state, action) => ({
      ...state,
      subscriptionPack: null
    })
  },
  initialState
)

export const getProducts = (searchText = '', from = null, to = null) => {
  return (dispatch, getState) => {
    if(from == null || to == null){
      const {page, rowsPerPage} = getState().products
      from = page;
      to = rowsPerPage;
    }
    
    dispatch(GET_PRODUCTS())
    return api
      .get('products/getProducts', '', `searchText=${searchText}&page=${from}&count=${to}`)
      .then(result => {
        dispatch(GET_PRODUCTS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const getProductsForCountry = country => {
  return dispatch => {
    dispatch(GET_PRODUCTS_FOR_COUNTRY())
    return api
      .get('products/getProductsForCountry', '', `country=${country}`)
      .then(result => {
        dispatch(GET_PRODUCTS_FOR_COUNTRY_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const getDisplayProducts = country => {
  return dispatch => {
    dispatch(GET_DISPLAY_PRODUCTS())
    return api
      .get('products/getDisplayProducts', '', `country=${country}`)
      .then(result => {
        dispatch(GET_DISPLAY_PRODUCTS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const setDisplayProduct = model => {
  return dispatch => {
    dispatch(SET_DISPLAY_PRODUCT())
    return api
      .post('products/setDisplayProduct', model.id, model)
      .then(result => {
        dispatch(SET_DISPLAY_PRODUCT_SUCCESS(result))
        dispatch(clearProducts())
        dispatch(getProducts())
        dispatch(resetDisplay())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(resetDisplay())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const removeDisplayProduct = id => {
  return dispatch => {
    dispatch(REMOVE_DISPLAY_PRODUCT())
    return api
      .post('products/removeFromDisplay', id, '')
      .then(result => {
        dispatch(REMOVE_DISPLAY_PRODUCT_SUCCESS(result))
        dispatch(clearProducts())
        dispatch(getProducts())
        dispatch(resetDisplay())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(resetDisplay())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const createProduct = product => {
  return dispatch => {
    dispatch(CREATE_PRODUCT())
    return api
      .post('products/createProduct', '', product)
      .then(result => {
        dispatch(CREATE_PRODUCT_SUCCESS(result))
        dispatch(clearProducts())
        dispatch(getProducts())
        dispatch(resetNew())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(resetNew())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const editProduct = product => {
  return dispatch => {
    dispatch(EDIT_PRODUCT())
    return api
      .post('products/updateProduct', product.id, product)
      .then(result => {
        dispatch(EDIT_PRODUCT_SUCCESS(result))
        dispatch(clearProducts())
        dispatch(getProducts())
        dispatch(resetActive())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const deleteItems = () => {
  return (dispatch, getState) => {
    const productIds = getState().products.selectedItems.map(p => p.id)
    dispatch(DELETE_PRODUCTS())
    return api
      .post('products/deleteProducts', null, { productIds: productIds })
      .then(result => {
        dispatch(DELETE_PRODUCTS_SUCCESS(result))
        dispatch(clearProducts())
        dispatch(getProducts())
        dispatch(unselectAll())
        dispatch(resetActive())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const search = searchText => {
  return dispatch => {
    dispatch(getProducts(searchText))
  }
}

export const setActive = product => {
  return dispatch => {
    dispatch(SET_ACTIVE(product))
  }
}

export const resetActive = () => {
  return dispatch => {
    dispatch(RESET_ACTIVE())
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}

export const setDisplay = (productId, displayProduct) => {
  return dispatch => {
    dispatch(SET_DISPLAY({ productId, displayProduct }))
  }
}

export const resetDisplay = () => {
  return dispatch => {
    dispatch(RESET_DISPLAY())
  }
}

export const updateDisplay = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_DISPLAY({ name, value }))
  }
}

export const setNew = () => {
  return dispatch => {
    // init a new product
    const product = {
      name: '',
      ean: '',
      dataMb: 0,
      sms: 0,
      days: 0,
      country: 'Sweden',
      smsActive: false,
      dataActive: false,
      uri: '',
      suggestedRefillProductId: 0
    }
    dispatch(SET_NEW(product))
  }
}

export const resetNew = () => {
  return dispatch => {
    dispatch(RESET_NEW())
  }
}

export const selectItem = item => {
  return dispatch => {
    dispatch(SELECT_ITEM(item))
  }
}

export const unselectItem = item => {
  return dispatch => {
    dispatch(UNSELECT_ITEM(item))
  }
}

export const unselectAll = () => {
  return dispatch => {
    dispatch(UNSELECT_ALL())
  }
}

export const toggleAll = checked => {
  return dispatch => {
    dispatch(TOGGLE_ALL(checked))
  }
}

export const setSort = value => {
  return dispatch => {
    dispatch(SET_SORT(value))
  }
}

export const setFilter = (name, value) => {
  return dispatch => {
    dispatch(SET_FILTER({ name, value }))
  }
}

export const setPage = value => {
  return dispatch => {
    dispatch(SET_PAGE(value))
  }
}

export const setRowsPerPage = value => {
  return dispatch => {
    dispatch(SET_ROWS_PER_PAGE(value))
  }
}

export const clearProducts = () => {
  return dispatch => {
    dispatch(CLEAR_PRODUCTS())
  }
}

export const setActiveSubscriptionPack = subscriptionPack => {
  return dispatch => {
      dispatch(SET_ACTIVE_SUBPACK(subscriptionPack))
  }
}

export const clearActiveSubscriptionPack = () => {
  return dispatch => {
      dispatch(CLEAR_ACTIVE_SUBPACK())
  }
}


// WEBPACK FOOTER //
// ./src/store/products/index.js